/**
 * The app pages' top bar: the app's name (back to your teams), this server, the theme, and who
 * is signed in (leading to their account's page) with the way out.
 */
import { Show, type JSX } from "solid-js";
import { usePages } from "./context";

/** The top bar. */
export function TopBar(): JSX.Element {
  const { accounts, server, go, theme } = usePages();
  const me = () => accounts.me(server);
  return (
    <header class="pages-top">
      <a
        class="brand"
        href="/"
        onClick={(e) => {
          e.preventDefault();
          go({ page: "home" });
        }}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">
          <circle cx="6" cy="7" r="2.4" />
          <circle cx="18" cy="6" r="2.4" />
          <circle cx="12" cy="18" r="2.4" />
          <path d="M8 8l3 8M16.4 8L13 16M8.4 7h7.2" />
        </svg>
        <h1>Knodal</h1>
      </a>
      <span class="mono small muted" title="The server these teams live on">
        {new URL(server).host}
      </span>
      <span class="pages-top-end">
        <button type="button" class="btn" id="pages-theme" title="Switch between system, light and dark" onClick={() => theme.cycle()}>
          {{ system: "System", light: "Light", dark: "Dark" }[theme.mode()]}
        </button>
        <Show when={me()}>
          {(m) => (
            <>
              <a
                class="pages-me"
                id="pages-me"
                href="/account"
                title={`${m().account.email}: your account and its safety`}
                onClick={(e) => {
                  e.preventDefault();
                  go({ page: "account" });
                }}
              >
                {m().account.name}
              </a>
              <button type="button" class="btn" id="pages-signout" onClick={() => void accounts.signOut(server).then(() => go({ page: "home" }))}>
                Sign out
              </button>
            </>
          )}
        </Show>
      </span>
    </header>
  );
}
